import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ConfigurationState, I18n, PresetColor, FontFamily} from '../../../types';
import config, {MenuOrientation, ThemeDirection, ThemeMode} from '../../../configs/themeConfig';
import {AppRootState} from '../../appStore';

let initialState: ConfigurationState = config;

export const configurationSlice = createSlice({
    name: 'Configurations',
    initialState,
    reducers: {
        onChangeContainer: (state, action: PayloadAction<boolean>) => {
            state.container = action.payload;
        },
        onChangeLocalization: (state, action: PayloadAction<I18n>) => {
            state.i18n = action.payload;
        },
        onChangeMode: (state, action: PayloadAction<ThemeMode>) => {
            state.mode = action.payload;
        },
        onChangePresetColor: (state, action: PayloadAction<PresetColor>) => {
            state.presetColor = action.payload;
        },
        onChangeDirection: (state, action: PayloadAction<ThemeDirection>) => {
            state.themeDirection = action.payload;
        },
        onChangeMiniDrawer: (state, action: PayloadAction<boolean>) => {
            state.miniDrawer = action.payload;
        },
        onChangeMenuOrientation: (state, action: PayloadAction<MenuOrientation>) => {
            state.menuOrientation = action.payload;
        },
        onChangeMenuCaption: (state, action: PayloadAction<boolean>) => {
            state.menuCaption = action.payload;
        },
        onChangeFontFamily: (state, action: PayloadAction<FontFamily>) => {
            state.fontFamily = action.payload;
        },
        onChangeContrast: (state, action: PayloadAction<boolean>) => {
            state.themeContrast = action.payload;
        },
    },
});

export const {
    onChangeContainer,
    onChangeLocalization,
    onChangeMode,
    onChangePresetColor,
    onChangeDirection,
    onChangeMiniDrawer,
    onChangeMenuOrientation,
    onChangeMenuCaption,
    onChangeFontFamily,
    onChangeContrast,
} = configurationSlice.actions;

export const configurationSliceReducer = configurationSlice.reducer;
export const configurationSelector = (rootState: AppRootState): ConfigurationState => rootState.configurations;
